export const CONTACT_PAGE_CONTENT = {
  hero: {
    label: 'GET IN TOUCH',
    title: 'Contact',
    description: 'Ready to elevate your aerial operations? Contact us to discuss your project requirements.',
  },
  contactInfo: {
    heading: 'Get in Touch',
    description: 'Ready to elevate your aerial operations? Contact our team to discuss your project requirements.',
  },
  headquarters: {
    title: 'HEADQUARTERS',
    address: 'Wasfi Al Tal Street\nP.O Box 2233\nIrbid 21163, Jordan',
  },
  phone: {
    title: 'PHONE & FAX',
    telLabel: 'Tel:',
    telNumber: '+962 27 102 026',
    telLink: 'tel:+96227102026',
    faxLabel: 'Fax:',
    faxNumber: '+962 27 102 044',
  },
  email: {
    title: 'EMAIL',
    emailAddress: 'info@imadar.com',
    emailLink: 'mailto:info@imadar.com',
  },
  businessHours: {
    label: 'BUSINESS HOURS',
    hours: 'Sunday - Thursday: 8:00 AM - 5:00 PM\nFriday - Saturday: Closed',
  },
  location: {
    title: 'Location',
  },
};